export default __webpack_public_path__ + "static/media/charging-guide-finger@2x.28715355.png";